<template>
  <div class="p-front__content">
   
    <!-- {{ regSuccess }} -->
    <div class="p-signup" style="vertical-align:middle">
       <div v-if="shouldNotBeHere">
      <Center>
        <h1>You probably shouldn't be here</h1>
      </Center>
    </div>
      <form class="p-signup__form" v-if="!regSuccess">
        <h4 class="p-signup__form-heading">Verify Email</h4>
        <div class="p-signup__form-content">
          <b-alert variant="danger" dismissible :show="displayError">{{ errorMessage }}</b-alert>
        </div>
      </form>
      <div v-if="regSuccess" class="p-signup__form" style="text-align:center">
        <span class="fa fa-thumbs-up fa-fw" style="font-size:12em; color:#0b75c1;"></span>
        <div class="p-signup__form-content" style="font-size:14px; text-align:center">
          Email verified successfully
          <router-link class="link-info btn btn-info" :to="`/auth/new-password/${regParams.userId}/${regParams.accessToken}`">Continue</router-link>
        </div>
      </div>
      <div v-if="!regSuccess" class="p-signup__form" style="text-align:center">
        <span class="fa fa-exclamation-triangle fa-fw" style="font-size:12em; color:#0b75c1;"></span>
        <div class="p-signup__form-content" style="font-size:14px; text-align:center">
          Email verification not successful, back to
          <router-link class="link-info" to="/auth/login">Sign In</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
// import { VueNotifications } from '../../main';
import axios from "axios";

export default {
  name: "register",
  data() {
    return {
      regSuccess: false,
      shouldNotBeHere: false,
      cpassword: null,
      regParams: {
        accessToken: null,
        userId: null
      },
      errors: {},
      displayError: false,
      errorMessage: ""
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        // console.log(`${field}: ${value}`);
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }
        switch (field) {
          case "newPassword":
            if (value === "null" || value === "") {
              errors[field] = "Password cannot be empty.";
            } else if (value !== this.cpassword) {
              errors[field] = "Password did not match.";
            }
            break;
          default:
            break;
        }
      }
      this.errors = errors;
    },
    submitRequest(userId, token) {
      this.validateReg();
      var container = this;
      var errorLength = Object.keys(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({ message: errorMsg });
      } else {
        this.regParams.userId = userId;
        this.regParams.accessToken = token;
        var str = JSON.stringify(this.regParams);
        const tempReg = JSON.parse(str);
        const HTTP = this.$httpUtils.instance;
        const url = "/users/confirm-email-from-token";
        HTTP.post(`${url}?access_token=${token}`, tempReg)
          .then(response => {
            container.regSuccess = true;
          })
          .catch(error => {
            container.regSuccess;
            var errorMsg = error.response.data.error.message;
            this.showErrorMsg({ message: errorMsg });
          });
      }
    }
  },
  mounted() {
    console.log(this.$route.params.uid);
    console.log(this.$route.params.token);

    if (!this.$route.params.uid || !this.$route.params.token) {
      this.shouldNotBeHere = true;
      console.log(this.shouldNotBeHere);
    } else {
      // if(window.location.search != ""){
      //   let src = new URLSearchParams(window.location.search).get(src);
      //   if()
      // }
      this.submitRequest(this.$route.params.uid, this.$route.params.token);
    }
    // this.regParams.accessToken = this.$route.params.token;
  }
};
</script>
<style  scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #0094f2;
}
#reg_success {
  position: absolute;
  /* height: 100vh; */
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/EmailConfirmed.vue